/**
 * Horrible regex validations from downstream
 */
export const last4DigitsPattern = /^[0-9]{4}$/;

export const streetAddressPattern = /^[a-zA-Z\d\s,]*$/;
export const cityPattern = /^[a-zA-Z .']{2,18}$/;
export const usZipCodePattern = /^[0-9]{5}$/;

export const emailPattern = /^.+@.+\..+$/i;
export const fdmpEmailPattern = /^[a-zA-Z0-9_!#$%&'*+\\=?`{|}~^-]+(?:\.[a-zA-Z0-9_!#$%&'*+\\=?`{|}~^-]+)*@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+$)/;
export const rfc5322CompliantEmailPattern = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
export const phonePattern = /[2-9](.*\d.*){9,}/;
export const businessPattern = /^[a-zA-Z0-9\x00-\x5A\x61-\x7B',_}~\\]{2,24}$/;
export const namePattern = /^[a-zA-Z]+[a-zA-Z ]*$/;
export const formatPhonePattern = /(\d{3})(\d{3})(\d{4})/;

// 12 digits long; can start with '0' or '00', but not '000'; ends with '88x' or '99x' (per Ronnie Mongan)
export const midPattern = /^(?:00[1-9]|0[1-9][0-9]|[1-9][0-9]{2})[0-9]{6}(?:88|99)[0-9]$/;
